<template>
    <v-expansion-panels v-model="panel">
        <v-expansion-panel class="bg-black pb-5">
        <v-expansion-panel-title class="  pb-5 text-h5" :class="data.class" >
            <v-container>
                <h3 class="text-h4">
                    {{ data.title }}
                </h3>
            </v-container>
        </v-expansion-panel-title>
        <v-expansion-panel-text class=" pb-5 " >
            <v-container>
                <v-row no-gutters align="center">
                    <v-col cols="12" >
                        <v-progress-linear height="2" color="primary" model-value="100"></v-progress-linear>
                    </v-col>
                    <v-col cols="12" v-for="(item, index) in data.list" :key="index" >
                        <v-container class="text-h6 text-md-h5">
                            <v-row>
                                <v-col cols="8" class="text-start">{{ item.title }}</v-col>
                                <v-col class="text-end">
                                    <b>{{ item.text }}</b>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-progress-linear height="2" color="primary" model-value="100"></v-progress-linear>
                    </v-col>
                </v-row>
            </v-container>
        </v-expansion-panel-text>
            
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: 'ExpansionList',
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
        panel: [],
    }),
    mounted(){
        if(this.data.open){
            this.panel = [0]
        }
    }
}
</script>